import * as React from "react";
import { XYCoord, useDragLayer } from "react-dnd";

import Card from "./Card";
import styled from "styled-components";

const StyledDiv = styled.div`
  height: 3em;
  width: 2em;
`;
const DragLayer = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  font-size: 5vw;
`;

function getDragLayerStyles(
  initialOffset: XYCoord | null,
  currentOffset: XYCoord | null
) {
  if (!initialOffset || !currentOffset) {
    return {
      display: "none",
    };
  }

  let { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
}

const DragPreview = () => {
  const { isDragging, item, initialOffset, currentOffset } = useDragLayer(
    (monitor) => ({
      item: monitor.getItem(),
      initialOffset: monitor.getInitialSourceClientOffset(),
      currentOffset: monitor.getSourceClientOffset(),
      isDragging: monitor.isDragging(),
    })
  );

  const renderItem = () => {
    const { isHighlighted, selected, ...rest } = item.props;
    return (
      <Card
        enabled={item.enabled}
        selected={true}
        isHighlighted={false}
        {...rest}
      ></Card>
    );
  };

  if (!isDragging) {
    return null;
  }

  return (
    <DragLayer>
      <StyledDiv style={getDragLayerStyles(initialOffset, currentOffset)}>
        {renderItem()}
      </StyledDiv>
    </DragLayer>
  );
};

export default DragPreview;
